/**
 * successful状态列表
 */
export const SUCCESSFUL_LIST = [
  { value: true, label: '是' },
  { value: false, label: '否' },
];
